export default __webpack_public_path__ + "static/media/lock.1a85efb2.svg";